module.exports = __webpack_public_path__ + "img/disabledTick.3116a9dc.png";